(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(function () {
            var $container = $('.countries-best-price-widget');
            var $tabs = $('.countries-best-price-city');

            $tabs.click(function (event) {
                var $this = $(event.currentTarget);
                var id = $this.data('id');

                $('.city-item-prices').removeClass('active');
                $tabs.removeClass('active');
                $this.addClass('active');

                var $tab = $container.find(".city-" + id);
                if ($tab.length) {
                    $tab.addClass('active');
                }

                event.preventDefault();
            });

            if ($tabs.length) {
                $(window).on('onLocation', function (event, city) {
                    var $currentCity = $tabs.filter('[data-id="' + city.id + '"]');
                    if ($currentCity.length) {
                        $currentCity.click();
                    }
                });
            }
        });
    }, {}] }, {}, [1]);